import { WorkflowIcon } from '@/components';
import { useLastCommentSearchHistory } from '@/features/comment/hooks/local-storage';
import { useSearchHistory } from '@/features/project/_hooks/search-projects/local-storage';
import { useLastWorkflowSearchHistory } from '@/features/workflow/hooks/local-storage';
import { t } from '@/i18n';
import {
  BarChartOutlined,
  CodeOutlined,
  CommentOutlined,
  ProjectOutlined,
  TableOutlined,
  TagsOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';
import { useNotificationBadges } from '../_hooks/notification-badge';
import { type TopMenuItem, sideMenuKeyEnum } from '../_utils/side-menu';

export const SIDE_MENU = (): TopMenuItem[] => {
  const { lastSearchedQueryParams } = useSearchHistory();
  const { commentPathWithQuery } = useLastCommentSearchHistory();
  const { workflowPathWithQuery } = useLastWorkflowSearchHistory();
  const notificationBadges = useNotificationBadges();

  return [
    {
      label: t('analysis-menu'),
      key: sideMenuKeyEnum.Enum.analysis,
      path: '/analysis/review-sheet',
      icon: <ProjectOutlined aria-label="" />,
    },
    {
      label: t('project-menu'),
      key: sideMenuKeyEnum.Enum.project,
      path: `/rs/project?${lastSearchedQueryParams.toString()}`,
      icon: <BarChartOutlined aria-label="" />,
    },
    {
      key: sideMenuKeyEnum.Enum.comment,
      path: `/${commentPathWithQuery}`,
      label: t('comment'),
      icon: <CommentOutlined aria-label="" />,
      isShowNotificationBadge: notificationBadges.comment.isShow,
      notificationBadgeCount: notificationBadges.comment.count,
      notificationBadgeColor: 'red',
    },
    {
      key: sideMenuKeyEnum.Enum.workflow,
      path: `/${workflowPathWithQuery}`,
      label: t('workflow'),
      icon: <WorkflowIcon aria-label="" />,
      isShowNotificationBadge: notificationBadges.workflow.isShow,
      notificationBadgeCount: notificationBadges.workflow.count,
      notificationBadgeColor: 'red',
    },
    {
      label: t('batch.menu'),
      key: sideMenuKeyEnum.Enum.batch,
      path: '/batch',
      icon: <CodeOutlined aria-label="" />,
    },
    {
      label: t('scope-tag-menu', { scope: t('global-tag') }),
      key: sideMenuKeyEnum.Enum.globalTag,
      path: '/tag/global',
      icon: <TagsOutlined aria-label="" />,
    },
    {
      label: t('scope-tag-menu', { scope: t('local-tag') }),
      key: sideMenuKeyEnum.Enum.localTag,
      path: '/tag/local',
      icon: <TagsOutlined aria-label="" />,
    },
    {
      label: t('master-table-menu'),
      key: sideMenuKeyEnum.Enum.masterTable,
      path: '/master-table',
      icon: <TableOutlined aria-label="" />,
    },
    {
      label: t('tenant-manager-menu'),
      key: sideMenuKeyEnum.Enum.tenantManager,
      path: '/tenant-manager',
      icon: <UsergroupAddOutlined aria-label="" />,
    },
  ];
};
